<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <vs-prompt
      title="Add reason"
      @cancel="newName = ''"
      @accept="acceptAlert"
      @close="activePrompt = false"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        New reason name
        <vs-input placeholder="Name" v-model="newName" class="w-full" />
      </div>
    </vs-prompt>

    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Wastage and spoilage</h3>
        <p class="mt-5 mb-6">
          Settings related to wastage and spoilage. These settings on a per
          country basis.
        </p>
      </vs-col>
    </vs-row>

    <vx-card no-shadow>
      <h5>Wastage reasons</h5>
      <div class="vx-row mb-6 mt-3">
        <div class="vx-col sm:w-1/5 mt-2 w-full">
          <span>Stock waste reasons:</span>
        </div>
        <div class="vx-col">
          <vs-chip
            :key="chip.id"
            closable="true"
            @click="removeChip(chip.id, 'Stock')"
            v-for="chip in stockWastageReasons"
          >
            {{ chip.name }}
          </vs-chip>
        </div>
      </div>


      <div class="vx-row mb-6 mt-3">
        <div class="vx-col sm:w-1/5 mt-2 w-full">
          <span>Sales waste reasons:</span>
        </div>
        <div class="vx-col">
          <vs-chip
            :key="chip.id"
            closable="true"
            @click="removeChip(chip.id, 'Sales')"
            v-for="chip in salesWastageReasons"
          >
            {{ chip.name }}
          </vs-chip>
        </div>
      </div>

      <vs-row  class="flex flex-wrap items-center mt-2">
        <vs-button id="save-button" @click="add('Sales')" class="mt-2 mr-4"
          >New sales reason</vs-button
        >
        <vs-button id="save-button" @click="add('Stock')" class="mt-2"
          >New stock reason</vs-button
        >
      </vs-row>

      <!-- Save & Remove Button -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      isLoading: true,
      activePrompt: false,
      newName: "",
      type: "",
    };
  },
  methods: {
    removeChip(chip, type) {
      console.log("Confirm remove chip", chip);
      // Prompt user if sure
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Remove wastage reason",
        text: "Are you sure?",
        accept: () => {
          console.log("Removing chip", chip);
          this.delete(chip, type);
        },
      });
    },
    async delete(chip, type) {
      console.log("Deleting chip", chip);
      this.$vs.loading();
      try {
        await this.$store.dispatch(
          "pimSettings/delete" + type + "WastageReason",
          chip
        );
        this.$vs.notify({
          color: "green",
          title: "Deleted",
          text: "Wastage reason deleted",
        });
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Error deleting",
          text: "Error deleting",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    add(type) {
      this.activePrompt = true;
      this.type = type;
    },
    async acceptAlert() {
      console.log("Accept alert", this.newName);
      // Add newName to wastage reasons
      await this.$store.dispatch(
        "pimSettings/add" + this.type + "WastageReason",
        {
          name: this.newName,
        }
      );

      this.$vs.notify({
        color: "green",
        title: "Added",
        text: "Wastage reason added",
      });
    },
  },
  computed: {
    ...mapGetters({
      //   emailSignature: "email/emailSignature",
      stockWastageReasons: "pimSettings/stockWastageReasons",
      salesWastageReasons: "pimSettings/salesWastageReasons",
    }),
  },

  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch("pimSettings/getSalesWastageReasons");
    await this.$store.dispatch("pimSettings/getStockWastageReasons");
    console.log("Stock Wastage reasons", this.stockWastageReasons);
    console.log("Sales Wastage reasons", this.salesWastageReasons);
    this.isLoading = false;
  },
};
</script>

